
<div class="flex-box" fillComponentParentView="fillComponentParentView">
  <div class="flex-heading">
    <div class="list-header col-xs-12"><span class="pR25">FollowUp Report</span></div>
  </div>
  <div class="flex-content">
    <iframe class="hbox" *ngIf="webAppUrl" [src]="webAppUrl"></iframe>
    <div class="texxtC p-2 fw-600" *ngIf="!report">No reports available</div>
  </div>
</div>